import Constant from "@constant/index.js";
import Intercept from "@observer/Intercept.js";

export default class BookingView{
    constructor(model){
        this._model = model;
        this._model._view = this;
        this._parentEl = this._model._parent._view._headerBoxEl;
        this._el = null;
    }

    render(){
        let html = "";
        let tips = "";
        if(this._model._deduction == '待公布') {
            // tips = `<span class="item"><span class="le_color_red" >${this._model._deduction}</span></span>`;
        } else {
            if(this._model._deposit && this._model._deduction){
                tips = `<span class="item"><span >${this._model._deposit}元定金</span><span class="le_color_red" >可抵扣${this._model._deduction}元</span></span>`;
            }
        }
        if(this._model._parent._parent._itemType != Constant.GROUP_TYPE.PACKAGE.TYPE){           
            html += `<div class="good_item_head" tag='booking'>
                    <span class="item le_tag">${this._model._name}</span>
                    <span class="item"><span tag='bookingdesc'>${this._model._desc}</span>&nbsp;<span class="le_color_red" tag='bookingleft'>${this._model._leftTime}</span></span>
                    ${tips}
                </div>`

            // if(this._model._parent._parent._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE){
            //     $(this._parentEl).append($(html));
            // }else{
            //     $(this._parentEl).prepend($(html));
            // }
            $(this._parentEl).append($(html));
            this._el = $(this._parentEl).find("[tag='booking']");
            this.interceptList();
        }
    }

    interceptList(){
        let time = $(this._el).find("[tag=bookingleft]");
        new Intercept().init(time, this._model, "_leftTime");

        let desc = $(this._el).find("[tag=bookingdesc]");
        new Intercept().init(desc, this._model, "_desc");
    }
}